import {css} from 'aphrodite';
import React from 'react';

import {isAnalysisTemplatesEnabled} from 'analysis-tool/AnalysisToolFeatureGates';

import {
  automationFileConfigStyles,
  AutomationOutputFileConfigEditorProps,
  SectionNumber,
} from '../AutomationFileConfigUtils';
import DatasetConfigEditor from './DatasetConfigEditor';
import SetColumnsMapEditor from './SetColumnsMapEditor';

export default function AutomationOutputFileConfigEditorColumnsMapSection(
  props: AutomationOutputFileConfigEditorProps
): JSX.Element {
  return (
    <div className={css(automationFileConfigStyles.subsection, automationFileConfigStyles.subsectionBorder)}>
      <SectionNumber sectionNumber={4} />
      <div className={css(automationFileConfigStyles.innerTitle)}>Configure column mapping</div>
      <div className={css(automationFileConfigStyles.description)}>
        Tell Benchling how to interpret the columns in your output file.
      </div>
      <SetColumnsMapEditor {...props} shouldShowUploadedFilesOnly={true} />
      {props.outputFileConfig.shouldCreateDataset && (
        <>
          <div
            className={css(
              automationFileConfigStyles.description,
              automationFileConfigStyles.sectionDescriptionAbove
            )}
          >
            {isAnalysisTemplatesEnabled()
              ? 'Select columns for your dataset and optionally enable automatic column mapping to an analysis template.'
              : 'Select columns for your dataset.'}
          </div>
          <DatasetConfigEditor {...props} />
        </>
      )}
    </div>
  );
}
